<template>
  <div
    class="product-variations"
    v-if="name === selectedVariationOption || editProduct"
  >
    <span
      class="product-variations__name"
      v-if="display_string"
    >
      {{ display_string }}:
    </span>
    <ul class="product-variations__list">
      <template
        v-for="(option, number) in variationsToShow"
      >
        <li
          class="product-variations__variation"
          v-if="number < variations.length"
          :class="variations[number].value === initialSelectedValue ? 'active' : ''"
          :key="variations[number].value"
        >
          <input
            type="radio"
            :name="`${name}_${index}`"
            :value="variations[number].value"
            :id="`${name}_${number}_${index}`"
            class="radio-input__input"
            ref="radio"
            v-model="value"
            @change="productUpdateHandler"
            :disabled="isVariationDisabled(number)"
            @onkeydown="handleKeyDownLabel"
          >
          <label
            class="radio-input radio-input__box"
            :class="{'radio-input--disabled' : isVariationDisabled(number)}"
            :for="`${name}_${number}_${index}`"
            @keydown="handleKeyDownLabel"
            tabindex="0"
          >
            {{ variations[number].label }}
          </label>
        </li>
      </template>
      <li
        class="product-variations__variation product-variations__variation--showmore"
        v-if="variationsToShow < variations.length || variations.length > variationsToShow"
        @click="variationsToShow+=variationShowMore"
        role="button"
        tabindex="0"
        @keydown="handleKeyDown"
        :aria-label="$t('global.show_more.button')"
      >
        <a class="product-variations__variation--showmore-button">{{ $t('global.show_more.button') }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
  import breakpoints from '../../variables/js/breakpoints.js';
  import grid from '../../variables/js/grid.js';
  import { nextTick } from "vue";

  export default {
    props: {
      variations: {
        type: Array,
        default: () => []
      },
      name: String,
      display_string: String,
      initialSelectedValue: String,
      index: Number,
      productDetail: {
        type: Boolean,
        default: false
      },
      variationOption: {
        type: Array,
        default: () => []
      },
      editProduct: Boolean
    },
    computed: {
      selectedVariationOption() {
        return "var[" + this.variationOption[0] + "]";
      },
    },
    data() {
      return {
        value: this.initialSelectedValue ? this.initialSelectedValue : this.variations[0].value,
        isMobile: window.innerWidth <= breakpoints.laptop,
        totalVariationsLength: 0,
        variationsToShow: 0,
        variationShowMore: grid.counter
      };
    },
    mounted() {
      this.totalVariationsLength = this.variations.length;
      this.variationsToShow = this.isMobile ? grid.numberVariationsMobile : grid.numberVariationsDesktop;
    },
    emits: ['changeVariation'],
    methods: {
      productUpdateHandler() {
        nextTick(() => this.$emit('changeVariation'))
      },
      getValue() {
        return this.value;
      },
      setValue(newValue) {
        this.value = newValue;
      },
      handleKeyDown(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.target.click();
        }
      },
      handleKeyDownLabel(event) {
        if (event.key === 'Enter' || event.code === 'Space') {
          event.preventDefault();
          event.target.previousSibling.click();
        }
      },
      isVariationDisabled(index) {
        return !this.variations[index].isAvailable;
      }
    },
    watch: {
      initialSelectedValue(newVal) {
        this.value = newVal || this.variations[0].value;
      }
    }
  };

</script>
